import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * @param {Event} event
   */
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    event.stopPropagation();
    super.increaseQuantity(event);
  }

  /**
   * At quantity 1, minus removes the line via the shared cart update flow.
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    event.stopPropagation();

    const { min, value } = this.getCurrentValues();
    const line = Number(this.refs.quantityInput.dataset.cartLine);

    if (value <= min) {
      const cartItems = this.closest('cart-items-component');
      if (cartItems && typeof /** @type {any} */ (cartItems).removeCartLineOptimistically === 'function' && line) {
        /** @type {any} */ (cartItems).removeCartLineOptimistically(line, event.target);
      }
      return;
    }

    this.updateQuantity(-1);
  }

  /**
   * @param {Event} event
   */
  setQuantity(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    event.preventDefault();
    event.stopPropagation();
    super.setQuantity(event);
  }
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Minus stays enabled at min qty so the next click removes the line (qty 0).
    minusButton.disabled = value < min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
